import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LaravelResourceResponse } from '../../../../../../../../_base-shared/contracts/laravel-response.interface';
import { User } from '../../../../../../../../_base-shared/models/User/User';
import { MainGlobalEventService } from '../../../../../_shared/services/main-global-event.service';
import { SharedModule } from '../../../../../_shared/shared.module';
import { CaseDocumentService } from '../../../case-document.service';

@Component({
  selector   : 'app-request-account-unlocking-dialog',
  imports    : [
    SharedModule,
  ],
  templateUrl: './request-account-unlocking-dialog.component.html',
  standalone : true,
  styles     : []
})
export class RequestAccountUnlockingDialogComponent implements OnInit, OnDestroy {
  public authUser: User;
  public isLoading                             = 0;
  public form: UntypedFormGroup;
  public isSubmitting                          = 0;
  public caseId: number;
  public serverResponse: LaravelResourceResponse;
  public clientRole: 'client' | 'partner';
  protected subscriptions: Array<Subscription> = [];

  constructor(private fb: UntypedFormBuilder,
              public dialogRef: MatDialogRef<RequestAccountUnlockingDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { caseId: number; clientRole: 'client' | 'partner' },
              private toastr: ToastrService,
              protected cookieService: CookieService,
              protected translate: TranslateService,
              private globalEventsService: MainGlobalEventService,
              private caseDocumentService: CaseDocumentService) {
    this.caseId = data.caseId;
    this.clientRole = data.clientRole;
  }

  ngOnInit(): void {
    this.buildForm();
    this.subscriptions.push(
      this.globalEventsService.authUser$.subscribe({
        next:  user => {
          this.authUser = user;
        },
        error: err => console.error(err),
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  private buildForm(): void {
    this.form = this.fb.group({
      bank_manager_email: [null, [Validators.required, Validators.email]],
      client_role: [this.clientRole]
    });
  }

  public onNoClick(): void {
    this.dialogRef.close();
  }

  public submitAction(): void {
    this.serverResponse = null;

    this.isLoading++;
    this.caseDocumentService.requestAccountUnlocking(this.caseId, this.form.getRawValue()).pipe(finalize(() => this.isLoading--))
      .subscribe({
        next:  () => {
          this.toastr.success(this.translate.instant('CASES.single.successfully_sent'));
          this.dialogRef.close();
        },
        error: (error) => {
          this.serverResponse = error.error;
          this.toastr.error(this.translate.instant('SHARED.went_wrong'));
        }
      });
  }
}
